/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { dispatch } from 'store';
import { activeItem } from 'store/slices/menu';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const { isLoggedIn, user } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname) {
            dispatch(activeItem(location.pathname.split('/')[1]));
        }
        if (
            (location.pathname.includes('users') ||
                location.pathname.includes('access-logs') ||
                location.pathname.includes('bulk-upload')) &&
            user.type !== 'admin'
        ) {
            navigate('/facilities', { replace: true });
        }
    }, [location.pathname]);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('login', { replace: true });
        }
    }, [isLoggedIn, navigate]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
